import moment from 'moment'

export const displayEffectiveHourFromObservation = observation =>
  observation && observation.effectiveDateTime
    ? moment(observation.effectiveDateTime).format('HH[h]mm')
    : '--:--'
